import React, {createContext, useContext} from 'react';

const BottomSheetContext = createContext({
  state: {},
  hideBottomSheet: () => {},
  showBottomSheet: () => ({
    id: 'id',
    hide: () => {},
  }),
});

export function useBottomSheet() {
  return useContext(BottomSheetContext);
}

export const BottomSheetProvider = ({children}) => {
  const [state, setState] = React.useState({});

  const destroyBottomSheet = React.useCallback((id) => {
    setState((prevState) => {
      const {[id]: x, ...newState} = prevState;
      return newState;
    });
  }, []);

  const hideBottomSheet = React.useCallback(
    (id) => {
      setState((prevState) => ({
        ...prevState,
        [id]: {
          ...prevState[id],
          props: {
            ...(prevState[id] ? prevState[id].props : {}),
            open: false,
          },
        },
      }));
      setTimeout(destroyBottomSheet, 1000);
    },
    [destroyBottomSheet],
  );

  const showBottomSheet = React.useCallback(
    (component, props = {}) => {
      const id = `${(+new Date()).toString(16)}`;

      setState((prevState) => ({
        ...prevState,
        [id]: {
          component,
          props: {
            ...props,
            open: false,
          },
        },
      }));

      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          [id]: {
            component,
            props: {
              ...props,
              open: true,
            },
          },
        }));
      }, 0);

      return {id, hide: () => hideBottomSheet(id)};
    },
    [hideBottomSheet],
  );

  function renderState() {
    return Object.keys(state).map((id) => {
      const {component: Component, props} = state[id];

      return Component ? (
        <Component
          {...props}
          key={id}
          onClose={() => hideBottomSheet(id)}
          onExited={() => destroyBottomSheet(id)}
        />
      ) : null;
    });
  }

  return (
    <BottomSheetContext.Provider
      value={{hideBottomSheet, showBottomSheet, state}}
    >
      {children}
      {renderState()}
    </BottomSheetContext.Provider>
  );
};
